import React from 'react'
import { TransitionOpacityPropsInterface, TransitionOpacityStateInterface } from './types'

class TransitionOpacity extends React.Component<TransitionOpacityPropsInterface, TransitionOpacityStateInterface> {

  _FPS = 12
  _tickTimeout

  state = {
    opacity: 0,
    tickInProgress: false,
    ticksTillCompletion: null,
    totalTicks: null
  }

  componentDidMount () {

    this.setupTransition()

  }

  componentWillUnmount () {

    clearTimeout(this._tickTimeout)

  }

  componentDidUpdate (prevProps, prevState) {

    const hasPropsChanged = (...props: string[]): boolean =>
      props.some(prop => prevProps[prop] !== this.props[prop])
    const hasStateChanged = (...props: string[]): boolean =>
      props.some(prop => prevState[prop] !== this.state[prop])

    if (hasPropsChanged('duration', 'onComplete', 'opacity')) {

      this.setupTransition()

    }

    if (hasStateChanged('ticksTillCompletion')) {

      if ((this.state.ticksTillCompletion || 0) <= 0) this.props.onComplete()
      else this.triggerTick()

    }

  }

  setupTransition = () => {

    const totalTicks = this.props.duration * this._FPS

    this.setState({
      opacity: this.props.opacity.from,
      ticksTillCompletion: totalTicks,
      totalTicks
    })

  }

  getOpacity = (ticksTillCompletion: number): number => {

    if (ticksTillCompletion === 0) return this.props.opacity.to

    const totalTicks = this.state.totalTicks || 1
    const numTimesTicked = totalTicks - ticksTillCompletion

    const test = this.props.opacity.from - this.props.opacity.to
    const chunkSize = test === 0
      ? 0
      : test / totalTicks

    return this.props.opacity.from - chunkSize * numTimesTicked

  }

  triggerTick = (): void => {

    if (!this.state.tickInProgress) {

      const ticksTillCompletion = this.state.ticksTillCompletion || 0

      if (ticksTillCompletion > 0) {

        this.setState({ tickInProgress: true })

        this._tickTimeout = setTimeout(() => {

          const nextTTC = ticksTillCompletion - 1
          this.setState({
            opacity: this.getOpacity(nextTTC),
            ticksTillCompletion: nextTTC,
            tickInProgress: false
          })

        }, (this.state.totalTicks || 0) * 10)

      }

    }

  }

  render () {

    return <div style={{ opacity: this.state.opacity }} >
      {this.props.children}
    </div>

  }

}

export default TransitionOpacity
